import { Dispatch } from 'react';
import {
  UPDATE_CAR_MODEL_FILTERS, UpdateCarModelFiltersAction,
  GET_CAR_MODELS_LIST,
  GET_CAR_MODEL,
  POST_CAR_MODEL,
  DELETE_CAR_MODEL,
  PUT_CAR_MODEL,
} from '../types/carmodel.types';
import { CoreApi } from '../../../api/api.apiclient';
import { CarModelListFilters, CarModelRequest } from '../../../api/core/core.types';
import { STORE_NEW_TOKEN } from '../../authentication/types/authentication.types';
import { PageRequest } from '../../../api/api.types';

export const getCarModelsList = (countRatePlans?: boolean, filters?: CarModelListFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.CarModels.listAllCarModels(countRatePlans, filters, page);

    dispatch({
      type: STORE_NEW_TOKEN,
      payload: {
        token: response.accessToken
      }
    });

    dispatch({
      type: GET_CAR_MODELS_LIST,
      payload: {
        page: response.data
      }
    });

    return Promise.resolve();
  } catch (e) {
    return Promise.reject();
  }
};

export const getCarModel = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.CarModels.getOneCarModel(id);

    dispatch({
      type: STORE_NEW_TOKEN,
      payload: {
        token: response.accessToken
      }
    });

    dispatch({
      type: GET_CAR_MODEL,
      payload: {
        selectedCarModel: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_CAR_MODEL,
      payload: {
        selectedCarModel: null
      }
    });
  }
};

export const addNewCarModel = (request: CarModelRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.CarModels.addNewCarModel(request);

  dispatch({
    type: STORE_NEW_TOKEN,
    payload: {
      token: response.accessToken
    }
  });

  dispatch({
    type: POST_CAR_MODEL,
    payload: {
      success: true,
      newCarModel: response.data
    }
  });
};

export const deleteCarModel = (id: number) => async (dispatch: Dispatch<any>) => {
  await CoreApi.CarModels.deleteCarModel(id);

  dispatch({
    type: DELETE_CAR_MODEL,
    payload: {
      success: true
    }
  });
};

export const editCarModel = (id: number, request: CarModelRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.CarModels.editCarModel(id, request);

  dispatch({
    type: STORE_NEW_TOKEN,
    payload: {
      token: response.accessToken
    }
  });

  dispatch({
    type: PUT_CAR_MODEL,
    payload: {
      selectedCarModel: response.data
    }
  });
};

export const updateCarModelFilters = (filters: CarModelListFilters) => async (dispatch: Dispatch<UpdateCarModelFiltersAction>) => {
  dispatch({
    type: UPDATE_CAR_MODEL_FILTERS,
    payload: {
      filters
    }
  });
};
